import { pushFaroError } from "@/services/faro.service";

const UNKNOWN_NODE_TYPE_PATTERN = /Unknown node type:?\s*([A-Za-z][\w-]{0,63})/i;

export function reportTiptapContentError(error: Error): void {
  const nodeType = extractUnknownNodeType(error.message);
  pushFaroError(new Error("tiptap-content-error"), nodeType ? { nodeType } : {});
}

function extractUnknownNodeType(message: string): string | null {
  const match = message.match(UNKNOWN_NODE_TYPE_PATTERN);
  return match ? match[1] : null;
}
